import script from "./footer-vue.vue?vue&type=script&setup=true&lang=js"
export * from "./footer-vue.vue?vue&type=script&setup=true&lang=js"

import "./footer-vue.vue?vue&type=style&index=0&id=5f648685&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f648685"]])

export default __exports__